let lockInverse = false;

function lock() {
    lockInverse = true;
}

function unlock() {
    lockInverse = false;
}

function init() {
    console.log('ScrollInverseService is deprecated, use RemoteScroller component instead...');
    // window.addEventListener('wheel', (ev) => {
    //     if (lockInverse) return;
    //     if (ev.deltaY == 0) return;

    //     let elementUnderMouse = document.elementFromPoint(
    //         ev.clientX,
    //         ev.clientY
    //     );

    //     // const parent = elementUnderMouse.parentElement || elementUnderMouse;

    //     if (
    //         elementUnderMouse.tagName == 'TR' 
    //         || elementUnderMouse.tagName == 'TD')
    //         return;

    //     if (ev.deltaY != 0) {
    //         const scroll_speed = ev.deltaY;
    //         const containers = document.getElementsByClassName('horizontal-scroll');

    //         if (containers.length) {
    //             for (let i = 0; i < containers.length; i++) {
    //                 containers[i].scrollLeft += scroll_speed;
    //             }
    //         }

    //         //strucutre on cafe tab is not updated, so wee need a workaround
    //         const dashboardBlock = document.getElementById('cafeScrollBlock');

    //         if (dashboardBlock) {
    //             dashboardBlock.scrollLeft += scroll_speed;
    //         }
    //     }
    // });
}

export default {
    init,
    lock,
    unlock
}